export default __webpack_public_path__ + "static/media/unicrypt.ff96fb0b.png";